import { render, staticRenderFns } from "./ContactUsCard.vue?vue&type=template&id=a7358696&scoped=true"
import script from "./ContactUsCard.vue?vue&type=script&lang=js"
export * from "./ContactUsCard.vue?vue&type=script&lang=js"
import style0 from "./ContactUsCard.vue?vue&type=style&index=0&id=a7358696&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7358696",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/var/www/tubber-new/components/global/v/button.vue').default,VImg: require('/var/www/tubber-new/components/global/v/img.vue').default})
